enquire.register("screen and (max-width:47.9375em)", {
    match: function () {
        $("[data-id='login-button']").on('click', function(){
            if($("#registrationWhich").is(":visible"))
                $("#registrationWhich").slideToggle();
        });

        $("[data-id='registration-button']").on('click', function(){
            if($("#login").is(":visible"))
                $("#login").slideToggle();
        });
    }
});


var lightboxPopupInit = function () {
    var toggleResponsiveFancyboxButtons =
        $('[data-lightbox="withSmallScreenSliding"]'),

    //we have old implementation with [data-lightbox="panel"] (to show popup)
    // especially in repairs form, so need to exclude them otherwise it will add lightbox handler 
    toggleNormalFancyboxButtons = $('[data-lightbox]').
    not('[data-lightbox="withSmallScreenSliding"],[data-lightbox="panel"]'),
    toggleContent = null;

    //Normal Fancybox 
    toggleNormalFancyboxButtons.fancybox();


    //Responsive Fancybox
    toggleResponsiveFancyboxButtons.on('click', function () {
        var id = $(this).attr('href');
        toggleContent = $(id);
    });

    //Responsiveness for the fancybox display
    var onSmallerScreen = function () {
        toggleResponsiveFancyboxButtons.off('click.screensize')
        .on("click.screensize", function (evt) {
            evt.preventDefault();
            toggleContent.slideToggle();

            //add close button
            toggleContent.prepend('<button data-id="close-login" type="button" class="btn-close"><span class="visually-hidden">Close</span><span class="icon-close"></span></button>');
            $('[data-id="close-login"]').on("click", function () {
                toggleContent.slideUp();
            });
        });
    };

    //Desktop Login
    var onBiggerScreen = function () {
        toggleResponsiveFancyboxButtons.off('click.screensize').fancybox();
        $('[data-id="close-login"]').remove();
    };

    enquire.register("screen and (max-width:47.9375em)", {
        match: function () {
            $(document).off('click.fb-start');
            onSmallerScreen();
        },
        unmatch: function () {
            if (islington.checkValidity(toggleContent))
                toggleContent.hide();
        }
    });

    enquire.register("screen and (min-width:48em)", {
        match: function () {
            onBiggerScreen();
        },
        unmatch: function () {
            if (islington.checkValidity(toggleContent))
                toggleContent.hide();
        }
    }, true);
};


